import { render, staticRenderFns } from "./PromoBarE.vue?vue&type=template&id=639c3d32&scoped=true&"
import script from "./PromoBarE.vue?vue&type=script&lang=js&"
export * from "./PromoBarE.vue?vue&type=script&lang=js&"
import style0 from "./PromoBarE.vue?vue&type=style&index=0&id=639c3d32&prod&lang=css&"
import style1 from "./PromoBarE.vue?vue&type=style&index=1&id=639c3d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c3d32",
  null
  
)

export default component.exports